var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 62,
    viewBox: "0 0 69 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2009_13920",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 62
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.428772H68.3305V61.2526H0V0.428772Z",
    fill: "#ffffff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2009_13920)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1652 54.6825C31.3852 54.6825 29.3252 52.4805 29.3252 49.6425C29.3252 46.7885 31.3852 44.5865 34.1652 44.5865C36.9452 44.5865 39.0052 46.7885 39.0052 49.6425C39.0052 52.4805 36.9452 54.6825 34.1652 54.6825ZM38.1835 16.1265L37.9135 23.3725L36.7955 40.0505H31.5335L30.4175 23.3725L30.1475 16.1265H38.1835ZM67.4894 51.9406L39.5414 3.53255C37.1514 -0.607449 31.1794 -0.607449 28.7894 3.53255L0.841386 51.9406C-1.54861 56.0786 1.43739 61.2526 6.21739 61.2526H62.1134C66.8914 61.2526 69.8794 56.0786 67.4894 51.9406Z",
    fill: "#a71f23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.8cf6cbd86bcdfeb39a8ab3e98422dfee.svg";
export { ForwardRef as ReactComponent };